import React from "react";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import MenuSection from "@/components/MenuSection";
import FaqSection from "@/components/FaqSection";

export default function Menu() {
  return (
    <div className="min-h-screen bg-background">
      <Navbar />
      <main id="main-content" tabIndex="-1" style={{ scrollMarginTop: "80px" }}>
        <div className="max-w-5xl mx-auto px-6 pt-32 pb-10 text-center">
          <p className="font-accent text-[10px] tracking-[0.45em] uppercase text-primary mb-3" aria-hidden="true" lang="it">Il Nostro Menu</p>
          <h1 className="font-display text-4xl md:text-6xl text-foreground mb-4">
            Our <em className="not-italic italic text-primary">Neapolitan</em> Menu
          </h1>
          <p className="font-body text-sm text-muted-foreground max-w-2xl mx-auto leading-relaxed">
            Brick oven pizza, the Neapolitan Genovese, pasta, and Italian classics, all prepared with ingredients imported directly from Italy. Every dish honors the traditions of A' Cucina 'e Mammà. We are a Neapolitan restaurant first, serving authentic Neapolitan pizza in the Upper East Side from our brick oven, and what many guests call the best Neapolitan pizza on the Upper East Side.
          </p>
        </div>
        <MenuSection showHeader={false} />
        <FaqSection path="/menu" />
      </main>
      <Footer />
    </div>
  );
}